@import '@styles/fonts.scss';
@import '@styles/colors.scss';

// Liftable spec: canvas 02 `.modelchip` (desktop) / canvas 07 `.mchip` (mobile) — same shape,
// responsive sizing only.

.chip {
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg, 10px);
    padding: 11px 14px;
    margin-top: 14px;
    text-decoration: none;
    transition: border-color 150ms ease;

    &:hover { border-color: var(--border-med); }
    &:focus-visible { outline: 2px solid var(--yolk); outline-offset: 2px; }
}

.mark {
    flex-shrink: 0;
}

.text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.name {
    font-family: var(--font-body);
    font-size: 13.5px;
    font-weight: 600;
    font-style: normal;
    color: var(--text);
}

.meta {
    font-family: var(--font-mono);
    font-size: 10px;
    font-style: normal;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--text-dim);
    margin-top: 1px;
}

.readyTag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
    font-family: var(--font-mono);
    font-size: 10.5px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--yolk);
    background: var(--yolk-dim);
    border: 1px solid var(--yolk-med);
    border-radius: var(--radius-pill, 9999px);
    padding: 3px 10px;
    white-space: nowrap;
}

.dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--yolk);
}

@media (max-width: 639px) {
    .chip {
        padding: 10px 12px;
    }

    .mark {
        width: 18px;
        height: 18px;
    }

    .metaReady {
        display: none;
    }
}
